module.exports = __webpack_public_path__ + "img/diente-blanco-gris.147969f3.png";